<template>
<div class="page-container-content tabgroup">
  <component :is="currentView" :active="active" ref="currentComponent"></component>
</div>
</template>

<script>
import eq from 'lodash/eq';
import { mapGetters } from 'vuex';

import WTopologymapConfigCommonGroup from '@/views/topologymap/components/perfoper/config/components/TopologymapConfigCommonGroup';
import WTopologymapConfigServerGroup from '@/views/topologymap/components/perfoper/config/components/TopologymapConfigServerGroup';
import WTopologymapConfigNetdeviceGroup from '@/views/topologymap/components/perfoper/config/components/TopologymapConfigNetdeviceGroup';
import WTopologymapConfigNetinterfaceGroup from '@/views/topologymap/components/perfoper/config/components/TopologymapConfigNetinterfaceGroup';
import WTopologymapConfigDatabaseGroup from '@/views/topologymap/components/perfoper/config/components/TopologymapConfigDatabaseGroup';
import WTopologymapConfigE2eGroup from '@/views/topologymap/components/perfoper/config/components/TopologymapConfigE2eGroup';
import WTopologymapConfigSensorGroup from '@/views/topologymap/components/perfoper/config/components/TopologymapConfigSensorGroup';
import WTopologymapConfigVirtualGroup from '@/views/topologymap/components/perfoper/config/components/TopologymapConfigVirtualGroup';
import WTopologymapConfigApmGroup from '@/views/topologymap/components/perfoper/config/components/TopologymapConfigApmGroup';
import WTopologymapConfigServiceGroup from '@/views/topologymap/components/perfoper/config/components/TopologymapConfigServiceGroup';

export default {
  name: 'WTopologymapConfigIndex',
  components: {
    WTopologymapConfigCommonGroup,
    WTopologymapConfigServerGroup,
    WTopologymapConfigNetdeviceGroup,
    WTopologymapConfigNetinterfaceGroup,
    WTopologymapConfigDatabaseGroup,
    WTopologymapConfigE2eGroup,
    WTopologymapConfigSensorGroup,
    WTopologymapConfigVirtualGroup,
    WTopologymapConfigApmGroup,
    WTopologymapConfigServiceGroup,
  },
  props: {
    active: {
      type: Boolean,
      default: () => false,
    },
    perfViewType: {
      type: String,
      default: () => 'list',
    },
  },
  data() {
    return {
      currentView: WTopologymapConfigCommonGroup,
    };
  },
  computed: mapGetters(['selectedObjDefineIds']),
  watch: {
    selectedObjDefineIds: {
      handler(selectedList) {
        this.changeView(selectedList);
      },
      immediate: true,
    },
    active() {
      this.changeView(this.selectedObjDefineIds);
    },

  },
  methods: {
    /**
     * 상단 장비목록의 선택 장비가 변경될 경우 화면을 변경하기 위한 함수
     * @author kimjy
     * @param  {Array} selectedList 선택된 장비의 objDefineId 리스트
     */
    changeView(selectedList) {
      /*
        - 선택된 장비가 하나일 경우 해당 장비의 화면 출력
        - 선택된 장비가 없거나 하나 이상일 경우 공통 화면 출력
       */
      if (this.active) {
        if (selectedList.length === 1) {
          const objDefineId = selectedList[0];
          if (eq(objDefineId, 'SERVER')) {
            this.currentView = WTopologymapConfigServerGroup.name;
          } else if (eq(objDefineId, 'NETDEVICE')) {
            this.currentView = WTopologymapConfigNetdeviceGroup.name;
          } else if (eq(objDefineId, 'NETINTERFACE')) {
            this.currentView = WTopologymapConfigNetinterfaceGroup.name;
          } else if (eq(objDefineId, 'DBMS')) {
            this.currentView = WTopologymapConfigDatabaseGroup.name;
          } else if (eq(objDefineId, 'E2E_SERVICE')) {
            this.currentView = WTopologymapConfigE2eGroup.name;
          } else if (eq(objDefineId, 'FMS_SENSOR')) {
            this.currentView = WTopologymapConfigSensorGroup.name;
          } else if (eq(objDefineId, 'SERVICE')) {
            this.currentView = WTopologymapConfigServiceGroup.name;
          } else if (eq(objDefineId, 'VMS_OBJECT')) {
            this.currentView = WTopologymapConfigVirtualGroup.name;
          } else if (eq(objDefineId, 'WAS')) {
            this.currentView = WTopologymapConfigApmGroup.name;
          }
        } else {
          this.currentView = WTopologymapConfigCommonGroup.name;
        }
      }
    },
    close() {
      this.$store.dispatch('setObjDefineIds', []);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/topologymap/components/perfoper/config/TopologymapConfigIndex.vue